module.exports = __webpack_public_path__ + "img/zoom_in.bea02113.svg";